import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";
import { TextSwitchVariantEnum } from "./TextSwitch";

export const StyledTextSwitch = styled.div<{
  $disabled?: boolean;
  $fullWidth: boolean;
  $variant: TextSwitchVariantEnum;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "fit-content")};
  height: ${({ $variant }) =>
    $variant === TextSwitchVariantEnum.SQUARED ? "34px" : "fit-content"};
  border: 1px solid ${theme.colors.grey_5};
  padding: 2px;
  border-radius: ${({ $variant }) =>
    $variant === TextSwitchVariantEnum.SQUARED
      ? theme.variables.border_radius_1
      : theme.variables.border_radius_3};
`;

export const StyledTextSwitchItem = styled.div<{
  $isString: boolean;
  $isActive: boolean;
  $fullWidth: boolean;
  $disabled: boolean;
}>`
  display: flex;
  padding: ${({ $isString }) => ($isString ? "3px 15px" : "3px 8px")};
  width: ${({ $fullWidth }) => $fullWidth && "100%"};
  white-space: nowrap;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  z-index: 1;
  & svg {
    width: ${theme.variables.height_5};
    height: ${theme.variables.height_5};
  }
  & > svg path {
    stroke: ${({ $isActive, $disabled }) =>
      $disabled
        ? `${theme.colors.grey_3}`
        : $isActive
          ? `${theme.colors.white}`
          : `${theme.colors.black}`};
    transition: stroke 300ms ease-in;
  }
  & span {
    transition: color 300ms ease-in;
  }
`;

export const StyledSwitchBookmark = styled.div<{
  $allowTransitions?: boolean;
  $variant: TextSwitchVariantEnum;
}>`
  position: absolute;
  top: 2px;
  left: 0;
  height: calc(100% - 4px);
  background-color: ${theme.colors.purple};
  border-radius: ${({ $variant }) =>
    $variant === TextSwitchVariantEnum.SQUARED
      ? theme.variables.border_radius_6
      : theme.variables.border_radius_3};
  transition: ${({ $allowTransitions }) =>
    $allowTransitions ? "all 300ms cubic-bezier(0.4, 0, 0.2, 1)" : "none"};
  z-index: 0;
`;
